import { useHookResult } from 'utils/customHooks/use-hook-result';
import { useTemporaryQueryParams } from 'utils/customHooks/use-query-params';
import { useStatsigExperiment } from 'utils/customHooks/use-statsig-experiment';

const EXPERIMENT_PARAMETER_INFO = [
  {
    name: 'is_patient_v4_enabled',
    defaultValue: false as boolean,
  },
] as const;

export const usePatientV4RedirectExperiment = () => {
  const queryParams = useTemporaryQueryParams([{
    variableName: 'patientV4',
    paramKey: 'patient-v4',
  }]);

  const {
    experimentParameters,
    isReady,
  } = useStatsigExperiment('patient-v4_redirection', {
    parameterInfo: EXPERIMENT_PARAMETER_INFO,
  });

  const shouldRedirectToPatientV4 = Boolean(
    experimentParameters.is_patient_v4_enabled
    || typeof queryParams.patientV4 === 'string',
  );

  return useHookResult({
    shouldRedirectToPatientV4,
    isReady,
  });
};
